import { render, staticRenderFns } from "./RecuperaPassword.vue?vue&type=template&id=8015d04e&scoped=true&"
import script from "./RecuperaPassword.vue?vue&type=script&lang=js&"
export * from "./RecuperaPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecuperaPassword.vue?vue&type=style&index=0&id=8015d04e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8015d04e",
  null
  
)

component.options.__file = "RecuperaPassword.vue"
export default component.exports